// src/entities/authorComposer/components/common/AuthorDniBadge.tsx
import React from "react";
import { observer } from "mobx-react";
import { Chip } from "@mui/material";
import { CheckCircleIcon } from "../../../../icons";
import { useRootStore } from "../../../../store/contexts";
import { EstadoAutor, tieneDatosValidados } from "./authorStatus";

/** "Datos validados con DNI": el autor tiene al menos un dato validado por el server. */
export const AuthorDniBadge: React.FC<{ estado: EstadoAutor | null }> = observer(({ estado }) => {
  const { langStore } = useRootStore();
  if (!tieneDatosValidados(estado)) return null;
  return (
    <Chip
      size="small"
      color="success"
      variant="outlined"
      icon={<CheckCircleIcon />}
      label={langStore.authorDniValidatedRecord}
    />
  );
});
